// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { StyledTypography } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, ellipsis, mergeWithCss, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

interface ProductDescriptionVariantStyles {
    small?: ProductDescriptionStyles;
    medium?: ProductDescriptionStyles;
}

const sharedStyles: StyledProp = css`
    && {
        margin-bottom: 8px;
        align-items: flex-start;
        -webkit-box-align: start;
    }
`;
const sharedSmallTextStyles: TypographyProps = {
    size: 14,
    weight: fontConfig.weight.bold,
    color: "text.main",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
        vertical-align: unset;
        ${wrapInContainerStyles}
        ${ellipsis(2)}
        ${xScreen("lte", "md")} {
            ${ellipsis(3)}
        }
    `,
};
const sharedMediumTextStyles: TypographyProps = {
    variant: "h1",
    color: "text.main",
    css: css`
        letter-spacing: 0;
        vertical-align: unset;
        margin-bottom: 0;
        ${wrapInContainerStyles}
    `,
};

const productDescriptionVariantStyles: ProductDescriptionVariantStyles = {
    small: {
        productDetailDescription: {
            ...mergeWithCss(sharedSmallTextStyles, { css: sharedStyles }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedSmallTextStyles,
                    },
                    css: css`
                        width: auto;
                        &:hover ${StyledTypography} {
                            color: ${color("common.ui9")};
                        }
                    `,
                },
                { css: sharedStyles },
            ),
        },
    },
    medium: {
        productDetailDescription: {
            ...mergeWithCss(sharedMediumTextStyles, { css: sharedStyles }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedMediumTextStyles,
                    },
                    css: css`
                        width: auto;
                        &:hover ${StyledTypography} {
                            color: ${color("common.ui9")};
                        }
                    `,
                },
                { css: sharedStyles },
            ),
        },
    },
};

export default productDescriptionVariantStyles;
